import { VehicleProvider } from '@cbgms/api'

export const getGenericVehicleByRegistration = (registration: string, provider: VehicleProvider) => ({
  method: 'GET',
  url: `/modules/generic-vehicles/by-registration/${registration}`,
  params: {
    provider
  }
})
